import React from "react";
import { CardImg } from "reactstrap";

const AssignmentFiles = ({ files }) => {
  console.log(files);
  return (
    <div
      className="mt-4"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "16px",
      }}
    >
      {files &&
        files.map((fileUrl, index) => {
          const cleanedUrl = fileUrl.trim();
          const fileExtension = cleanedUrl.split(".").pop().toLowerCase();
          const isPdf = fileExtension === "pdf";

          return (
            <div key={index} className="text-center">
              <a
                href={cleanedUrl}
                download
                title="Download File"
                target="_blank"
                rel="noopener noreferrer"
              >
                {isPdf ? (
                  <i
                    className="bx bxs-file-pdf"
                    style={{ fontSize: "48px", color: "red" }}
                  />
                ) : (
                  <CardImg
                    src={encodeURI(cleanedUrl)}
                    alt="Assignment"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </a>
            </div>
          );
        })}
    </div>
  );
};

export default AssignmentFiles;
